/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * Module containing Cloud components.
 * @preferred
 * @module CloudServicesModule
 */

import {
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { ClrSpinnerModule } from '@clr/angular';
import { SharedModule } from 'ng/shared/shared.module';
import { AviFormsModule } from 'ng/modules/avi-forms/avi-forms.module';

import {
    cloudCollectionProvider,
    licenseBasedFeaturesServiceProvider,
    roleCollectionProvider,
    seGroupCollectionProvider,
} from './ajs-upgraded-providers';

import {
    VerifyCloudConnectorUserHostModalComponent,
    VerifyCloudConnectorUserHostModalService,
} from '.';

@NgModule({
    declarations: [
        VerifyCloudConnectorUserHostModalComponent,
    ],
    imports: [
        CommonModule,
        SharedModule,
        AviFormsModule,
        ClrSpinnerModule,
    ],
    providers: [
        cloudCollectionProvider,
        licenseBasedFeaturesServiceProvider,
        seGroupCollectionProvider,
        roleCollectionProvider,
        VerifyCloudConnectorUserHostModalService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class CloudServicesModule {}
